import { motion } from "framer-motion";
import { Zap, Target, Search, Handshake } from "lucide-react";
import { MeshDotsAmbience } from "./Ambience";

const pillars = [
  {
    icon: Zap,
    title: "Performance technique garantie",
    text: "Des sites ultra-rapides qui respectent les Core Web Vitals de Google. Temps de chargement optimisé = moins d'abandons, plus de conversions.",
  },
  {
    icon: Target,
    title: "Orienté résultats, pas juste esthétique",
    text: "Chaque élément de design est pensé pour convertir : call-to-actions stratégiques, parcours utilisateur optimisé, formulaires qui incitent à l'action.",
  },
  {
    icon: Search,
    title: "SEO intégré dès la conception",
    text: "Pas besoin de payer un consultant SEO après coup. Structure optimisée, balisage correct, contenu pensé pour Google dès le premier jour.",
  },
  {
    icon: Handshake,
    title: "Accompagnement transparent",
    text: "Process clair à chaque étape, réponse rapide sous 24-48h, formation personnalisée. Vous n'êtes jamais seul après la livraison.",
  },
];

export default function WhyUs() {
  return (
    <section
      data-testid="whyus-section"
      className="relative overflow-hidden py-28 sm:py-40 px-5 sm:px-8 lg:px-12 border-t border-white/[0.06]"
    >
      <MeshDotsAmbience />
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
        <div className="lg:col-span-7">
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-6 block">
            (05) — Pourquoi ML.
          </span>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-tighter">
            Pourquoi <span className="text-outline">choisir</span> ML<span className="text-[var(--accent)]">.</span>
          </h2>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ delay: 0.15 }}
          className="lg:col-span-4 lg:col-start-9 text-zinc-400 text-base sm:text-lg leading-relaxed"
        >
          Pas de chiffres creux ni de promesses toutes faites. Ce qui compte vraiment : un site qui vous ressemble, qui se trouve, et qui convertit.
        </motion.p>
      </div>

      {/* Pillars */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06] rounded-2xl overflow-hidden">
        {pillars.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.div
              key={p.title}
              data-testid={`whyus-pillar-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.07, duration: 0.6 }}
              className="bg-[var(--bg-soft)] p-8 sm:p-10 group hover:bg-[#0d0d0d] transition-colors duration-500"
            >
              <Icon className="w-7 h-7 text-[var(--accent)] mb-6" strokeWidth={1.4} />
              <h3 className="font-display text-2xl sm:text-3xl tracking-tight mb-3">
                {p.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed">{p.text}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
